export const getAggRegionSteeringHint = () => window['GLOBAL_AGG_REGION_STEERING_HINT'];

export const initializeAggRegionSteeringHint = (fromValue: string): void => {
	if (!getAggRegionSteeringHint()) {
		window['GLOBAL_AGG_REGION_STEERING_HINT'] = fromValue;
	}
};
